<script>
export default {
  data() {
    return {
      dataMapMposParamsUrl:{
        token: process.env.VUE_APP_LINK_TOKEN_MPOS,
        callbackUri: process.env.VUE_APP_URL + '/setting/mpos-connect',
        isLink: 'yes',
        appName:'NEXT360'
      },
    };
  },
  methods: {
    clickMapMpos(){
      const link = process.env.VUE_APP_MAP_MPOS_URL + '?token='+this.dataMapMposParamsUrl.token+'&callbackUri='+this.dataMapMposParamsUrl.callbackUri+'&appName='+this.dataMapMposParamsUrl.appName+'&isLink='+this.dataMapMposParamsUrl.isLink
      window.location.href = link
    },
    clickSetting(){
      this.$router.push({ path: "/setting" });
    },
  },
};
</script>

<template>
  <div>
    <TheLayout>
      <div class="wrapBox card">
        <div>
          <img src="@/assets/images/N360.svg" style="border-radius: 8px; margin-right: 8px"/>
          <img src="@/assets/images/Mpos.svg" style="border-radius: 8px; margin-left: 5px"/>
        </div>
        <span class="content-form-card font-weight-bolder" style="margin:24px  auto 0">Gỡ liên kết thành công</span>
        <div class="mt-2">Gỡ liên kết thành công. Bạn có muốn liên kết tài khoản khác không?</div>
        <BaseButton size="size100" class="mt-2" @click="clickMapMpos">Liên kết tài khoản khác</BaseButton>
        <BaseButton variant="secondary" class="mt-2 bd-info" size="size100" @click="clickSetting">Quay lại cài đặt</BaseButton>
      </div>
    </TheLayout>
  </div>
</template>
<style scoped>
  .wrapBox{
    width: 400px;
    margin: 25px auto 0;
    text-align: center;
    padding: 20px;
    border: 1px solid #eee;
  }
  .bd-info{
    border: 1px solid #3e69f6;
  }
  .content-form-card{
    font-size: 15px;
  }
</style>
